import { Anchor, Box, Header } from 'grommet';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useAppContext from '../Context/useAppContext';
import onLogout from '../../../Utils/onLogout';

export interface AppHeaderProps {}

const AppHeader: React.FC<AppHeaderProps> = (): JSX.Element => {
  const {
    state: { IsAuthenticated, Theme },
    dispatch,
  } = useAppContext();

  const navigate = useNavigate();

  const onLoginClick = (): void => {
    navigate('/login');
  };

  const onLogoutClick = (): void => {
    onLogout()
      .then(() => {
        dispatch({
          type: 'changeAuth',
          value: false,
        });

        dispatch({
          type: 'changeFirstName',
          value: '',
        });

        dispatch({
          type: 'changeLastName',
          value: '',
        });

        toast.success('You have been logged out.');
        navigate('/login');
      })
      .catch((): void => {
        toast.error('Failed to log out.');
      });
  };

  const backgroundColor = Theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)';

  return (
    <Header
      background={backgroundColor}
      pad="medium"
      border={{ side: 'bottom', color: Theme === 'dark' ? 'dark-3' : 'light-4' }}
    >
      <Box
        direction="row"
        align="center"
        justify="end"
        gap="small"
        fill="horizontal"
      >
        {
          (IsAuthenticated) ? (
            <Anchor onClick={onLogoutClick} title="Logout" color="text-strong">Logout</Anchor>
          ) : (
            <Anchor onClick={onLoginClick} title="Login" color="text-strong">Login</Anchor>
          )
        }
      </Box>
    </Header>
  );
};

AppHeader.displayName = 'AppHeader';

export default AppHeader;
